(function () {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  const root = document.getElementById('cart-drawer-root');
  const config = {
    threshold: parseInt(drawer.dataset.threshold || '0', 10),
    currency: drawer.dataset.currency || 'KWD',
    upsellCollection: drawer.dataset.upsellCollection || '',
    checkoutUrl: drawer.dataset.checkoutUrl || '/checkout',
    cartUrl: drawer.dataset.cartUrl || '/cart',
    termsUrl: drawer.dataset.termsUrl || '/pages/terms-conditions',
    refundUrl: drawer.dataset.refundUrl || '/pages/return-policy',
    strings: {
      title: drawer.dataset.title || 'Your cart',
      spendMore: drawer.dataset.spendMore || 'Spend {{ amount }} more for FREE shipping!',
      freeShipping: drawer.dataset.freeShipping || "You've unlocked FREE shipping!",
      mightLike: drawer.dataset.mightLike || 'You might also like',
      giftWrapping: drawer.dataset.giftWrapping || 'Gift wrapping',
      orderNote: drawer.dataset.orderNote || 'Order Note',
      discountCode: drawer.dataset.discountCode || 'Discount Code',
      giftCard: drawer.dataset.giftCard || 'Gift card',
      giftCardTitle: drawer.dataset.giftCardTitle || 'GIFT CARD',
      giftCardPlaceholder: drawer.dataset.giftCardPlaceholder || 'Enter gift card code',
      giftCardHint: drawer.dataset.giftCardHint || 'Enter the code from your gift card email. It is applied at checkout.',
      shipping: drawer.dataset.shipping || 'Shipping',
      subtotal: drawer.dataset.subtotal || 'Subtotal',
      taxNote: drawer.dataset.taxNote || 'Shipping fees are calculated when you complete your order',
      checkout: drawer.dataset.checkout || 'Check out',
      empty: drawer.dataset.empty || 'Your cart is empty',
      continueShopping: drawer.dataset.continueShopping || 'Continue shopping',
      color: drawer.dataset.color || 'Color',
      size: drawer.dataset.size || 'Size',
      apply: drawer.dataset.apply || 'Apply',
      saveNote: drawer.dataset.saveNote || 'Save',
      shippingText: drawer.dataset.shippingText || '',
      discountHint: drawer.dataset.discountHint || 'Enter your discount code below.',
      standardShipping: drawer.dataset.standardShipping || 'Standard shipping: 2.000 KD',
      termsLabel: drawer.dataset.termsLabel || 'I agree to the Terms & Refund Policy',
      termsRequired: drawer.dataset.termsRequired || 'Please agree to the Terms & Refund Policy to continue',
      addOrderNote: 'ADD ORDER NOTE',
      discountTitle: 'DISCOUNT CODE',
      shippingTitle: 'SHIPPING',
      calculate: 'Calculate',
      countryRegion: 'Country/Region',
      postalCode: 'Postal/Zip code',
      howHelp: 'How can we help you?',
      enterDiscount: 'Please enter discount code',
      enterGiftCard: drawer.dataset.giftCardPlaceholder || 'Enter gift card code',
    },
  };

  let cart = null;
  let activePanel = null;
  let upsellOpen = true;
  let upsellProducts = [];
  let termsAccepted = false;

  // ── Money formatting ────────────────────────────────────────
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: config.currency,
      }).format(cents / 100);
    } catch (e) {
      return config.currency + ' ' + (cents / 100).toFixed(3);
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('hidden', count < 1);
    });
  }

  function cartApiUrl(path) {
    if (window.__giraffeCartApiUrl) return window.__giraffeCartApiUrl(path);
    return path;
  }

  function goToCheckoutWithGiftCard(code) {
    const clean = String(code || '').replace(/\s+/g, '');
    if (!clean) return;
    try {
      sessionStorage.setItem('giraffe_gift_card', clean);
    } catch (e) {}
    const checkout = config.checkoutUrl || '/checkout';
    const url = new URL(checkout, window.location.origin);
    url.searchParams.set('gift_card', clean);
    window.location.href = url.pathname + url.search + url.hash;
  }

  // ── API ─────────────────────────────────────────────────────
  async function fetchCart() {
    const res = await fetch(cartApiUrl('/cart.js'));
    cart = await res.json();
    return cart;
  }

  async function changeLine(key, quantity) {
    // Optimistic update — mutate cart in-memory and render immediately
    if (cart) {
      cart.items = cart.items
        .map((i) => {
          if (i.key !== key) return i;
          const newQty = Math.max(0, quantity);
          return { ...i, quantity: newQty, final_line_price: i.price * newQty };
        })
        .filter((i) => i.quantity > 0);
      cart.item_count = cart.items.reduce((s, i) => s + i.quantity, 0);
      cart.total_price = cart.items.reduce((s, i) => s + i.final_line_price, 0);
      updateCartCount(cart.item_count);
      render();
    }
    // Confirm with server
    const res = await fetch(cartApiUrl('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    cart = await res.json();
    return cart;
  }

  async function updateCart(payload) {
    const res = await fetch(cartApiUrl('/cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    cart = await res.json();
    return cart;
  }

  async function addToCart(items) {
    let addedQty = 0;
    if (cart) {
      addedQty = items.reduce((s, i) => s + (i.quantity || 1), 0);
      cart.item_count = (cart.item_count || 0) + addedQty;
      updateCartCount(cart.item_count);
    }
    const res = await fetch(cartApiUrl('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      if (cart && addedQty) {
        cart.item_count = Math.max(0, cart.item_count - addedQty);
        updateCartCount(cart.item_count);
      }
      throw new Error('Add to cart failed');
    }
    await fetchCart();
    return cart;
  }

  // ── Helpers ─────────────────────────────────────────────────
  function isDefaultVariantValue(value) {
    if (!value) return true;
    const v = String(value).trim().toLowerCase();
    return v === 'default title' || v === 'default' || v === 'title';
  }

  function isIgnorableOptionName(name) {
    if (!name) return true;
    const n = String(name).trim().toLowerCase();
    return n === 'title' || n === 'default title';
  }

  function labelForOption(name) {
    const n = String(name || '').toLowerCase();
    if (n === 'color' || n === 'colour' || n === 'اللون') return config.strings.color;
    if (n === 'size' || n === 'المقاس' || n.includes('size') || n.includes('مقاس')) return config.strings.size;
    return name;
  }

  function getVariantLabel(item) {
    if (item.options_with_values && item.options_with_values.length) {
      return item.options_with_values
        .filter((opt) => !isIgnorableOptionName(opt.name) && !isDefaultVariantValue(opt.value))
        .map((opt) => labelForOption(opt.name) + ': ' + opt.value)
        .join('<br>');
    }
    const parts = [];
    if (item.option1 && !isDefaultVariantValue(item.option1)) {
      const label = item.option2 ? config.strings.color : config.strings.size;
      parts.push(label + ': ' + item.option1);
    }
    if (item.option2 && !isDefaultVariantValue(item.option2)) {
      parts.push(config.strings.size + ': ' + item.option2);
    }
    if (item.option3 && !isDefaultVariantValue(item.option3)) {
      parts.push(item.option3);
    }
    return parts.join('<br>');
  }

  function shippingProgress(total) {
    if (!config.threshold) return { percent: 100, message: config.strings.freeShipping };
    const remaining = Math.max(0, config.threshold - total);
    const percent = Math.min(100, (total / config.threshold) * 100);
    const message =
      remaining > 0
        ? config.strings.spendMore.replace('{{ amount }}', formatMoney(remaining))
        : config.strings.freeShipping;
    return { percent, message };
  }

  // ── Upsell ──────────────────────────────────────────────────
  async function loadUpsell(cartData) {
    upsellProducts = [];

    if (cartData.items.length > 0) {
      const productId = cartData.items[0].product_id;
      try {
        const res = await fetch(
          cartApiUrl('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
        );
        const data = await res.json();
        upsellProducts = (data.products || []).slice(0, 4);
      } catch (e) {
        upsellProducts = [];
      }
    }

    if (upsellProducts.length === 0 && config.upsellCollection) {
      try {
        const res = await fetch(cartApiUrl('/collections/' + config.upsellCollection + '/products.json?limit=6'));
        const data = await res.json();
        upsellProducts = (data.products || []).slice(0, 4);
      } catch (e) {
        upsellProducts = [];
      }
    }
  }

  async function addUpsellVariant(variantId) {
    const existing = cart?.items?.find((i) => i.variant_id === variantId);
    if (existing) {
      await changeLine(existing.key, existing.quantity + 1);
      return;
    }
    await addToCart([{ id: variantId, quantity: 1 }]);
    render();
  }

  function renderUpsell() {
    if (!upsellProducts.length) return '';

    const cards = upsellProducts
      .map((product) => {
        const variant = product.variants.find((v) => v.available) || product.variants[0];
        if (!variant) return '';
        const img = product.featured_image || (product.images && product.images[0]);
        const imgSrc = img ? (typeof img === 'string' ? img : img.src) : '';
        return `
          <div class="cart-drawer__upsell-card">
            <img class="cart-drawer__upsell-img" src="${imgSrc}" alt="${product.title}" loading="lazy">
            <div class="flex-1 min-w-0">
              <p class="cart-drawer__upsell-vendor">${product.vendor || ''}</p>
              <p class="cart-drawer__upsell-name">${product.title}</p>
              <p class="cart-drawer__upsell-price">${formatMoney(variant.price)}</p>
              <button type="button" class="cart-drawer__upsell-add" data-upsell-add="${variant.id}" aria-label="Add to cart">
                <span class="material-symbols-outlined text-[16px]">shopping_bag</span>
              </button>
            </div>
          </div>`;
      })
      .join('');

    return `
      <div class="cart-drawer__upsell${upsellOpen ? ' is-open' : ''}">
        <button type="button" class="cart-drawer__upsell-toggle" data-upsell-toggle>
          <span>${config.strings.mightLike}</span>
          <span class="material-symbols-outlined cart-drawer__upsell-chevron text-[20px]">expand_more</span>
        </button>
        <div class="cart-drawer__upsell-panel">
          <div class="cart-drawer__upsell-track hide-scrollbar">${cards}</div>
        </div>
      </div>`;
  }

  // ── Items list ───────────────────────────────────────────────
  function renderItems(items) {
    if (!items.length) {
      return `
        <div class="cart-drawer__empty">
          <p>${config.strings.empty}</p>
          <a href="${window.__giraffeLocalizeUrl ? window.__giraffeLocalizeUrl('/') : '/'}" data-cart-drawer-close>${config.strings.continueShopping}</a>
        </div>`;
    }

    return items
      .map(
        (item) => `
      <div class="cart-drawer__item" data-line-key="${item.key}">
        <img class="cart-drawer__item-image" src="${item.image}" alt="${item.title}" loading="lazy" width="88" height="110">
        <div>
          <p class="cart-drawer__item-title">${item.product_title}</p>
          ${getVariantLabel(item) ? `<p class="cart-drawer__item-variant">${getVariantLabel(item)}</p>` : ''}
          <div class="cart-drawer__qty-row">
            <div class="cart-drawer__qty">
              <button type="button" data-qty-change="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty-change="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="cart-drawer__remove" data-qty-change="${item.key}" data-qty="0" aria-label="Remove item">
              <span class="material-symbols-outlined text-[18px]">delete</span>
            </button>
          </div>
        </div>
        <p class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</p>
      </div>`
      )
      .join('');
  }

  // ── Bottom sheet content per panel ──────────────────────────
  function renderSheetContent() {
    if (!activePanel) return '';

    if (activePanel === 'note') {
      return `
        <div class="cart-drawer__sheet-header">
          <h3 class="cart-drawer__sheet-title">${config.strings.addOrderNote}</h3>
          <button type="button" class="cart-drawer__sheet-close" data-sheet-close aria-label="Close">
            <span class="material-symbols-outlined text-[22px]">close</span>
          </button>
        </div>
        <textarea data-cart-note placeholder="${config.strings.howHelp}">${cart.note || ''}</textarea>
        <button type="button" class="cart-drawer__sheet-btn" data-save-note>${config.strings.saveNote}</button>`;
    }

    if (activePanel === 'discount') {
      return `
        <div class="cart-drawer__sheet-header">
          <h3 class="cart-drawer__sheet-title">${config.strings.discountTitle}</h3>
          <button type="button" class="cart-drawer__sheet-close" data-sheet-close aria-label="Close">
            <span class="material-symbols-outlined text-[22px]">close</span>
          </button>
        </div>
        <input type="text" data-discount-input placeholder="${config.strings.enterDiscount}">
        <button type="button" class="cart-drawer__sheet-btn" data-apply-discount>${config.strings.apply}</button>`;
    }

    if (activePanel === 'giftcard') {
      return `
        <div class="cart-drawer__sheet-header">
          <h3 class="cart-drawer__sheet-title">${config.strings.giftCardTitle}</h3>
          <button type="button" class="cart-drawer__sheet-close" data-sheet-close aria-label="Close">
            <span class="material-symbols-outlined text-[22px]">close</span>
          </button>
        </div>
        <p class="cart-drawer__sheet-label">${config.strings.giftCardHint}</p>
        <input type="text" data-gift-card-input placeholder="${config.strings.enterGiftCard}" autocomplete="off" autocapitalize="characters">
        <button type="button" class="cart-drawer__sheet-btn" data-apply-gift-card>${config.strings.apply}</button>`;
    }

    if (activePanel === 'shipping') {
      return `
        <div class="cart-drawer__sheet-header">
          <h3 class="cart-drawer__sheet-title">${config.strings.shippingTitle}</h3>
          <button type="button" class="cart-drawer__sheet-close" data-sheet-close aria-label="Close">
            <span class="material-symbols-outlined text-[22px]">close</span>
          </button>
        </div>
        <label class="cart-drawer__sheet-label">${config.strings.countryRegion}</label>
        <select data-ship-country>
          <option value="">---</option>
          <option value="KW">Kuwait</option>
          <option value="SA">Saudi Arabia</option>
          <option value="AE">United Arab Emirates</option>
          <option value="QA">Qatar</option>
          <option value="BH">Bahrain</option>
          <option value="OM">Oman</option>
          <option value="US">United States</option>
          <option value="GB">United Kingdom</option>
          <option value="DE">Germany</option>
          <option value="FR">France</option>
        </select>
        <label class="cart-drawer__sheet-label">${config.strings.postalCode}</label>
        <input type="text" data-ship-zip>
        <button type="button" class="cart-drawer__sheet-btn" data-calc-shipping>${config.strings.calculate}</button>
        <div data-ship-result class="cart-drawer__ship-result"></div>`;
    }

    return '';
  }

  // ── Sheet open/close with animation ──────────────────────────
  function openSheet() {
    // Double RAF: first frame creates the DOM at translateY(100%), second frame transitions to 0
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const wrap = root && root.querySelector('.cart-drawer__sheet-wrap');
        if (wrap) wrap.classList.add('is-open');
      });
    });
  }

  function closeSheet(callback) {
    const wrap = root && root.querySelector('.cart-drawer__sheet-wrap');
    if (!wrap || !wrap.classList.contains('is-open')) {
      if (callback) callback();
      return;
    }
    wrap.classList.remove('is-open');
    let fired = false;
    const done = () => {
      if (fired) return;
      fired = true;
      wrap.removeEventListener('transitionend', done);
      if (callback) callback();
    };
    wrap.addEventListener('transitionend', done);
    setTimeout(done, 400); // fallback in case transitionend doesn't fire
  }

  // ── Main render ─────────────────────────────────────────────
  function render() {
    if (!cart || !root) return;

    const progress = shippingProgress(cart.total_price);
    const giftChecked =
      cart.attributes && (cart.attributes['Gift wrapping'] === 'Yes' || cart.attributes['gift_wrapping'] === 'Yes');
    const sheetContent = renderSheetContent();

    root.innerHTML = `
      <div class="cart-drawer__header">
        <h2 class="cart-drawer__title" id="cart-drawer-title">${config.strings.title} (${cart.item_count})</h2>
        <button type="button" class="cart-drawer__close" data-cart-drawer-close aria-label="Close cart">
          <span class="material-symbols-outlined text-[22px]">close</span>
        </button>
      </div>

      ${cart.item_count > 0 && config.threshold ? `
      <div class="cart-drawer__shipping">
        <p class="cart-drawer__shipping-text">${progress.message}</p>
        <div class="cart-drawer__progress">
          <div class="cart-drawer__progress-bar" style="width:${progress.percent}%"></div>
        </div>
      </div>` : ''}

      <div class="cart-drawer__body">
        <div class="cart-drawer__items">${renderItems(cart.items)}</div>

        ${cart.item_count > 0 ? renderUpsell() : ''}

        ${cart.item_count > 0 ? `
        <div class="cart-drawer__extras">
          <label class="cart-drawer__gift">
            <input type="checkbox" data-gift-wrap ${giftChecked ? 'checked' : ''}>
            <span>${config.strings.giftWrapping}</span>
          </label>
          <div class="cart-drawer__actions">
            <button type="button" class="cart-drawer__action${activePanel === 'note' ? ' is-active' : ''}" data-panel="note">
              <span class="material-symbols-outlined text-[20px]">description</span>
              <span>${config.strings.orderNote}</span>
            </button>
            <button type="button" class="cart-drawer__action${activePanel === 'discount' ? ' is-active' : ''}" data-panel="discount">
              <span class="material-symbols-outlined text-[20px]">sell</span>
              <span>${config.strings.discountCode}</span>
            </button>
            <button type="button" class="cart-drawer__action${activePanel === 'giftcard' ? ' is-active' : ''}" data-panel="giftcard">
              <span class="material-symbols-outlined text-[20px]">card_giftcard</span>
              <span>${config.strings.giftCard}</span>
            </button>
            <button type="button" class="cart-drawer__action${activePanel === 'shipping' ? ' is-active' : ''}" data-panel="shipping">
              <span class="material-symbols-outlined text-[20px]">local_shipping</span>
              <span>${config.strings.shipping}</span>
            </button>
          </div>
        </div>` : ''}
      </div>

      ${cart.item_count > 0 ? `
      <div class="cart-drawer__footer">
        <div class="cart-drawer__subtotal-row">
          <span class="cart-drawer__subtotal-label">${config.strings.subtotal}</span>
          <span class="cart-drawer__subtotal-value">${formatMoney(cart.total_price)}</span>
        </div>
        <p class="cart-drawer__shipping-rate">${config.strings.standardShipping}</p>
        <p class="cart-drawer__tax-note">${config.strings.taxNote}</p>
        <label class="cart-drawer__terms">
          <input type="checkbox" data-terms-agree ${termsAccepted ? 'checked' : ''}>
          <span><a href="${config.termsUrl}" target="_blank" rel="noopener">${config.strings.termsLabel}</a></span>
        </label>
        <p class="cart-drawer__terms-error" data-terms-error hidden>${config.strings.termsRequired}</p>
        <button type="button" class="cart-drawer__checkout" data-cart-checkout>${config.strings.checkout}</button>
      </div>` : ''}

      <div class="cart-drawer__sheet-wrap">
        <div class="cart-drawer__sheet-bg" data-sheet-close></div>
        <div class="cart-drawer__sheet">${sheetContent}</div>
      </div>
    `;

    bindEvents();
    updateCartCount(cart.item_count);

    // If a panel is active, animate the sheet up after DOM is painted
    if (activePanel) openSheet();
  }

  // ── Event binding ────────────────────────────────────────────
  function bindEvents() {
    // Close drawer
    root.querySelectorAll('[data-cart-drawer-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    // Close sheet — slide down first, then re-render
    root.querySelectorAll('[data-sheet-close]').forEach((el) => {
      el.addEventListener('click', () => {
        closeSheet(() => {
          activePanel = null;
          render();
        });
      });
    });

    // Qty / remove — changeLine already renders optimistically; server-confirm + final render
    root.querySelectorAll('[data-qty-change]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.qtyChange;
        const qty = parseInt(btn.dataset.qty, 10);
        await changeLine(key, qty);   // optimistic render fires inside changeLine
        await loadUpsell(cart);
        render();                      // final render with confirmed server data
      });
    });

    // Gift wrap
    const gift = root.querySelector('[data-gift-wrap]');
    if (gift) {
      gift.addEventListener('change', async () => {
        await updateCart({ attributes: { 'Gift wrapping': gift.checked ? 'Yes' : 'No' } });
      });
    }

    // Terms checkbox — required before checkout (native Shopify checkout can't host this)
    const terms = root.querySelector('[data-terms-agree]');
    const termsError = root.querySelector('[data-terms-error]');
    if (terms) {
      terms.addEventListener('change', () => {
        termsAccepted = terms.checked;
        if (termsError) termsError.hidden = termsAccepted;
      });
    }

    const checkoutBtn = root.querySelector('[data-cart-checkout]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', () => {
        if (!termsAccepted) {
          if (termsError) termsError.hidden = false;
          if (terms) terms.focus();
          return;
        }
        let storedGift = '';
        try {
          storedGift = sessionStorage.getItem('giraffe_gift_card') || '';
        } catch (e) {}
        if (storedGift) {
          goToCheckoutWithGiftCard(storedGift);
          return;
        }
        window.location.href = config.checkoutUrl || '/checkout';
      });
    }

    // Action buttons → open or close sheet
    root.querySelectorAll('[data-panel]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const panelName = btn.dataset.panel;
        if (activePanel === panelName) {
          // Toggle off — slide down then remove
          closeSheet(() => {
            activePanel = null;
            render();
          });
        } else {
          // Switch panel — render content, then animate up
          activePanel = panelName;
          render(); // sheet renders without is-open; openSheet() is called inside render()
        }
      });
    });

    // Save note
    const saveNote = root.querySelector('[data-save-note]');
    if (saveNote) {
      saveNote.addEventListener('click', async () => {
        const note = root.querySelector('[data-cart-note]')?.value || '';
        await updateCart({ note });
        closeSheet(() => {
          activePanel = null;
          render();
        });
      });
    }

    // Apply discount → redirect to checkout with code
    const applyDiscount = root.querySelector('[data-apply-discount]');
    if (applyDiscount) {
      applyDiscount.addEventListener('click', () => {
        const code = root.querySelector('[data-discount-input]')?.value?.trim();
        if (code) {
          window.location.href =
            '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(config.checkoutUrl);
        }
      });
    }

    const applyGiftCard = root.querySelector('[data-apply-gift-card]');
    if (applyGiftCard) {
      applyGiftCard.addEventListener('click', () => {
        const input = root.querySelector('[data-gift-card-input]');
        const code = input?.value?.trim();
        if (!code) {
          if (input) input.focus();
          return;
        }
        goToCheckoutWithGiftCard(code);
      });
    }
    const giftCardInput = root.querySelector('[data-gift-card-input]');
    if (giftCardInput) {
      giftCardInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyGiftCard && applyGiftCard.click();
        }
      });
    }

    // Shipping calculator
    const calcShipping = root.querySelector('[data-calc-shipping]');
    if (calcShipping) {
      calcShipping.addEventListener('click', async () => {
        const country = root.querySelector('[data-ship-country]')?.value || '';
        const zip = root.querySelector('[data-ship-zip]')?.value?.trim() || '';
        const resultEl = root.querySelector('[data-ship-result]');
        if (!resultEl) return;
        if (!country) { resultEl.innerHTML = '<p>Please select a country.</p>'; return; }

        resultEl.innerHTML = '<p>Calculating…</p>';
        try {
          const params = new URLSearchParams({
            'shipping_address[country]': country,
            'shipping_address[zip]': zip,
          });
          const res = await fetch(cartApiUrl('/cart/shipping_rates.json?' + params.toString()));
          if (!res.ok) throw new Error();
          const data = await res.json();
          const rates = data.shipping_rates || [];
          if (!rates.length) {
            resultEl.innerHTML = '<p>No shipping rates available for this address.</p>';
          } else {
            resultEl.innerHTML = rates
              .map(
                (r) =>
                  `<div class="rate"><span>${r.name}</span><span>${formatMoney(parseFloat(r.price) * 100)}</span></div>`
              )
              .join('');
          }
        } catch (e) {
          resultEl.innerHTML = '<p>Unable to calculate rates. Please check your address.</p>';
        }
      });
    }

    // Upsell toggle
    const upsellToggle = root.querySelector('[data-upsell-toggle]');
    if (upsellToggle) {
      upsellToggle.addEventListener('click', () => {
        upsellOpen = !upsellOpen;
        root.querySelector('.cart-drawer__upsell')?.classList.toggle('is-open', upsellOpen);
      });
    }

    // Upsell add to cart — keep product visible in upsell; increment qty if already in cart
    root.querySelectorAll('[data-upsell-add]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const variantId = parseInt(btn.dataset.upsellAdd, 10);
        btn.disabled = true;
        try {
          await addUpsellVariant(variantId);
        } finally {
          btn.disabled = false;
        }
      });
    });
  }

  // ── Open / Close ─────────────────────────────────────────────
  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');

    // Render immediately from cache so drawer shows content right away
    if (cart) {
      render();
    }

    // Fetch fresh data in background and silently update
    fetchCart().then(async (data) => {
      await loadUpsell(data);
      render();
    });
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    activePanel = null;
  }

  // ── Global hooks ─────────────────────────────────────────────
  document.querySelectorAll('[data-cart-drawer-toggle]').forEach((el) => {
    el.addEventListener('click', (e) => { e.preventDefault(); open(); });
  });

  drawer.querySelector('.cart-drawer__overlay')?.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (activePanel) {
        closeSheet(() => { activePanel = null; render(); });
      } else if (drawer.classList.contains('is-open')) {
        close();
      }
    }
  });

  // Intercept add-to-cart forms
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('action')?.includes('/cart/add') || form.id === 'product-form') {
      e.preventDefault();
      const formData = new FormData(form);
      const id = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || '1', 10);
      if (!id) return;
      try {
        const note = (formData.get('properties[Note]') || '').toString().trim();
        const payload = { id: parseInt(id, 10), quantity };
        if (note) payload.properties = { Note: note };
        await addToCart([payload]);
        await loadUpsell(cart);
        open();
      } catch (err) {
        console.error('Add to cart failed', err);
      }
    }
  });

  // Initialise badge count and pre-load upsell so it shows instantly on first open
  fetchCart().then(async (data) => {
    updateCartCount(data.item_count);
    await loadUpsell(data);
  });

  window.CartDrawer = { open, close, refresh: fetchCart, addToCart };
})();
